<fa-icon [icon]="faExclamationTriangle" style="color: orange; margin-left: 45%"></fa-icon>
<p>{{'ALERT_DD_USERS' | translate}}</p>
<div class="button-container">
  <button mat-button class="btn btn-success" matDialogClose>OK</button>
  <button mat-button id="cancel-button" class="btn" color="warn" (click)="cancelDragDrop()">{{"CANCEL"|translate}}</button>
</div>
